var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.25 8.62606C24.5325 8.94456 23.7615 9.15906 22.9522 9.25575C23.7785 8.76094 24.4131 7.97687 24.7113 7.0425C23.9386 7.50075 23.0822 7.83387 22.1706 8.01344C21.4418 7.23587 20.401 6.75 19.2505 6.75C16.6676 6.75 14.7696 9.15987 15.3529 11.6616C12.029 11.495 9.08125 9.9025 7.10769 7.48206C6.05956 9.28012 6.56412 11.6323 8.34512 12.8234C7.69025 12.8023 7.07275 12.6227 6.53406 12.3229C6.49019 14.1762 7.81862 15.9101 9.74262 16.2961C9.17956 16.4488 8.56287 16.4846 7.93562 16.3643C8.44425 17.9536 9.92137 19.1097 11.6731 19.1422C9.99125 20.4609 7.87225 21.05 5.75 20.7997C7.52044 21.9348 9.624 22.597 11.8827 22.597C19.3106 22.597 23.5072 16.3237 23.2537 10.6971C24.0353 10.1324 24.7137 9.428 25.25 8.62606Z",
    fill: "#1E8EEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2dfcf99b804af2ea50c8293a497736d1.svg";
export { ForwardRef as ReactComponent };